import React from 'react';
import { Outlet } from 'react-router';

const Questionnaire = props => {
    return <>
        <Outlet />
    </>
};

export default Questionnaire;